<template>
  <div>
    <Loading
      class="vasion-loading-indicator"
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="file-upload-container">
      <VasionFileUploadDialog
        :serverOptions="serverOptions"
        :show.sync="showUploadDialog"
        :acceptedFileTypes="['.csv']"
        :filePondLabel="filePondLabel"
        @allFilesUploaded="allFilesUploaded"
      />
      <VasionGeneralModal
        id="file-import-error-modal"
        :sync="showFileImportedErrorModal"
        :modalType="'slot'"
        :confirmButtonText="'Done'"
        :showRejectButton="false"
        :customButtonText="'Retry'"
        :customButtonDisabled="false"
        :showCustomButton="true"
        :modalTitle="'File Could not be Imported!'"
        :message="' Your file could not be Imported'"
        :showTitleAndMessage="true"
        @confirmButtonClick="fileImportErrorDone"
        @customButtonClick="retryFileImport"
      >
        {{ fileImportErrorMessage }}
      </VasionGeneralModal>
      <VasionGeneralModal
        id="import-preference-modal"
        :rejectButtonText="'Cancel'"
        :confirmButtonText="'Continue'"
        :sync="showImpPrefModal"
        :modalTitle="'Import Preference'"
        :message="' How would you like to import these new values?'"
        :modalType="'slot'"
        @noButtonClick="cancelImportPreference"
        @confirmButtonClick="importPreferenceContinue"
      >
        <div style="margin: 1rem;">
          <md-radio id="overwrite-values-radio" v-model="importPreference" value="overwrite-values">
            Overwrite Current Values
          </md-radio>
          <md-radio id="append-values-radio" v-model="importPreference" value="append-values">
            Append to Current Values
          </md-radio>
        </div>
      </VasionGeneralModal>
      <VasionGeneralModal
        id="file-import-confirm-overwrite-modal"
        :sync="showConfirmOverwriteModal"
        :modalType="'slot'"
        :confirmButtonText="'Yes'"
        :showRejectButton="false"
        :customButtonText="'No'"
        :customButtonDisabled="false"
        :showCustomButton="true"
        :modalTitle="'Overwrite Current Values'"
        :message="' Are you sure you want to overwrite all existing values for this dropdown field?'"
        :showTitleAndMessage="true"
        @confirmButtonClick="confirmOverwrite"
        @customButtonClick="cancelOverwrite"
      />
      <VasionGeneralModal
        id="file-imported-modal"
        :confirmButtonText="'Done'"
        :showRejectButton="false"
        :sync="showFileImportedModal"
        :modalTitle="'File Imported!'"
        :showTitleAndMessage="true"
        :message="' Your file was successfully imported'"
        :modalType="'message'"
        @confirmButtonClick="fileImportedDone"
      />
    </div>
    <VasionGeneralModal
      id="create-new-field"
      :modalType="'slot'"
      :confirmButtonText="editingField ? 'UPDATE' : 'CREATE'"
      :rejectButtonText="'CANCEL'"
      :sync="showDialog"
      @noButtonClick="editingField ? toggleFieldEdit('') : toggleAddNewField()"
      @confirmButtonClick="editingField ? editField() : addNewField()"
    >
      <div class="innerDiv dialog">
        <div class="title">
          <div>
            <label v-if="creatingNewField" class="vasion-page-title">New Field</label>
            <label v-else class="vasion-page-title">Edit Field</label>
          </div>
          <div class="search-dropdown">
            <VasionDropList
              v-if="allFieldHeaders"
              v-slot="slotItem"
              v-model="localConfig.fieldUniqueName"
              :dataArray="allFieldHeaders"
              :returnValueOnly="true"
              :isDisabled="editingField"
              width="100%"
              :title="editingField ? 'UNIQUE NAME' : 'SEARCH EXISTING FIELD'"
              type="plain-list"
              placeholder="Select Existing Field..."
              :displayName="searchName"
              :valueName="searchName"
              @input="setFieldValues"
            >
              {{ slotItem.item.name }}
            </VasionDropList>
          </div>
        </div>
        <div class="md-layout md-gutter topBotMargin10">
          <div class="md-layout-item left-element">
            <VasionInput
              v-model="localConfig.fieldLabel"
              width="100%"
              class="input-style"
              inputType="top-white"
              title="LABEL"
              placeholder="Enter Field Label..."
              @input="!editingField ? userUniqueName = removeBadCharacters(localConfig.fieldLabel) : null"
            />
          </div>
          <div class="md-layout-item">
            <VasionInput
              v-if="showUniqueNameInput"
              v-model="userUniqueName"
              width="100%"
              class="input-style"
              inputType="top-white"
              title="UNIQUE NAME"
              placeholder="Enter Unique Name..."
              :isDisabled="true"
              @input="userUniqueName = removeBadCharacters(userUniqueName)"
            />
          </div>
        </div>
        <div class="md-layout md-gutter topBotMargin10">
          <div v-if="fieldTypeList" class="md-layout-item left-element">
            <VasionDropList
              v-slot="slotItem"
              v-model="localConfig.fieldType"
              :dataArray="fieldTypeList"
              :isDisabled="(editingField && !canEditTypeAndLength) || buildingFromExistingField"
              width="100%"
              title="TYPE"
              type="plain-list"
              valueName="id"
              displayName="value"
              placeholder="Select Type..."
            >
              {{ slotItem.item.value }}
            </VasionDropList>
          </div>
          <div v-if="localConfig.fieldType" class="md-layout-item">
            <VasionInput
              v-if="localConfig.fieldType.id == 1 || localConfig.fieldType.id == 13"
              id="field-length"
              v-model="localConfig.fieldLength"
              name="field-length"
              :isDisabled="(editingField && !canEditTypeAndLength) || buildingFromExistingField || ssnMask"
              :maxLengthProp="4"
              :specialType="'number'"
              width="100%"
              class="input-style"
              inputType="top-white"
              title="MAX LENGTH"
              placeholder="Enter Max Length..."
            />
            <div v-if="fieldtypeWithValues" class="input-option-group">
              <VasionInput
                id="field-values"
                v-model="newFieldValue"
                name="field-values"
                width="100%"
                class="input-style"
                inputType="top-white"
                title="VALUE"
                placeholder="Enter a New Value..."
                @input="newFieldValue = newFieldValue.replaceAll(',','').trimStart()"
                @keyup.enter="addNewFieldOption"
              />
              <VasionButton
                v-if="newFieldValue"
                id="add-new-field-option"
                class="button-adjust"
                classProp="primary"
                name="add-new-field-option"
                title="Add"
                @vasionButtonClicked="addNewFieldOption"
              >
                Add
              </VasionButton>
              <VasionButton
                id="import-file"
                class="button-adjust"
                classProp="primary-light"
                name="import-file"
                @vasionButtonClicked="importFile"
              >
                IMPORT FILE
              </VasionButton>
            </div>
          </div>
        </div>
        <div class="md-layout">
          <div v-if="showWarnLabel" class="warnLabel">
            Value already exists
          </div>
        </div>
        <div class="value-list" :class="{'value-list-with-extra-field': showUniqueNameInput}">
          <div v-if="fieldtypeWithValues" :key="listKey">
            <p class="cvs-note">
              <b>*The CSV file should not include commas or blank lines.</b>
            </p>
            <h5 class="value-list-header">
              {{ localConfig.fieldType.value }} Values
            </h5>
            <div
              v-for="(value, index) in localConfig.dropDownValues"
              :key="index"
              class="value"
              :class="{'vasion-lightest-grey-background': index % 2 === 0}"
            >
              <span>{{ value }}</span><span><VasionDeleteIcon class="delete-option" @click="deleteFieldOption(index)" /></span>
            </div>
          </div>
        </div>
        <div class="section-header">
          <label class="section-header-label">FIELD SETTINGS</label>
        </div>
        <div v-if="localConfig.fieldType" class="md-layout checkbox-group">
          <VasionCheckbox
            id="field-hidden"
            class="field-checkbox checkbox-flex"
            name="field-hidden"
            :checked="localConfig.fieldHidden"
            @change="localConfig.fieldHidden = !localConfig.fieldHidden"
          >
            Hidden
          </VasionCheckbox>

          <VasionCheckbox
            id="field-mandatory"
            class="field-checkbox checkbox-flex"
            name="field-mandatory"
            :checked="localConfig.mandatory"
            @change="mandatoryUpdated = true; localConfig.mandatory = !localConfig.mandatory"
          >
            Mandatory
          </VasionCheckbox>

          <VasionCheckbox
            id="field-readonly"
            class="field-checkbox checkbox-flex"
            name="field-readonly"
            :checked="localConfig.readOnly"
            @change="localConfig.readOnly = !localConfig.readOnly"
          >
            Read Only
          </VasionCheckbox>

          <VasionCheckbox
            id="field-pii-data"
            class="field-checkbox checkbox-flex"
            name="field-pii-data"
            :checked="piiData"
            @change="piiData = !piiData"
          >
            PII Data
          </VasionCheckbox>
          <VasionCheckbox
            v-show="localConfig.fieldType.id == 1"
            id="field-ssn-mask"
            class="field-checkbox checkbox-flex"
            name="field-ssn-mask"
            :checked="ssnMask"
            @change="ssnChange"
          >
            SSN Mask
          </VasionCheckbox>

          <VasionCheckbox
            v-show="localConfig.fieldType.id == 1"
            id="field-total-page-no"
            class="field-checkbox checkbox-flex"
            name="field-total-page-no"
            :checked="localConfig.totalPageNo"
            @change="localConfig.totalPageNo = !localConfig.totalPageNo"
          >
            Total Page #
          </VasionCheckbox>

          <VasionCheckbox
            v-show="localConfig.fieldType.id == 3"
            id="field-system-date"
            class="field-checkbox checkbox-flex"
            name="field-system-date"
            :checked="localConfig.systemDate"
            @change="localConfig.systemDate = !localConfig.systemDate"
          >
            System Date
          </VasionCheckbox>
          
          <VasionCheckbox
            v-show="localConfig.fieldType.id == 2"
            id="field-allow-multiple-values"
            class="field-checkbox checkbox-flex"
            name="field-allow-multiple-values"
            :checked="localConfig.allowMultiples"
            @change="localConfig.allowMultiples = !localConfig.allowMultiples"
          >
            Allow Multiple Values
          </VasionCheckbox>

          <VasionCheckbox
            v-show="localConfig.fieldType.id == 2"
            id="field-filter-values"
            class="field-checkbox checkbox-flex"
            name="field-filter-values"
            :checked="localConfig.filterValues"
            @change="filterValuesUpdate"
          >
            Filter Values
          </VasionCheckbox>
        </div>
        <div
          v-show="localConfig.fieldType.id == 6"
          class="md-layout checkbox-group number-checkbox-group"
        >
          <VasionCheckbox
            id="field-show-decimal-places"
            class="field-checkbox checkbox-flex"
            name="field-show-decimal-places"
            :checked="showDecimalPlaces"
            @change="showDecimalPlaces = !showDecimalPlaces"
          >
            Show Decimal Places
          </VasionCheckbox>

          <VasionCheckbox
            id="field-show-commas"
            class="field-checkbox checkbox-flex"
            name="field-show-commas"
            :checked="localConfig.showCommas"
            @change="localConfig.showCommas = !localConfig.showCommas"
          >
            Show Comma
          </VasionCheckbox>
          <div class="field-checkbox checkbox-flex">
            <!-- Placeholder -->
          </div>
        </div>
        <div
          v-show="localConfig.fieldType.id == 6"
          class="md-layout number-checkbox-group"
        >
          <VasionInput
            v-if="showDecimalPlaces"
            v-model="localConfig.decimalPlaces"
            inputType="top-white"
            :title="'Decimal Places'"
            specialType="number"
            :width="'100'"
          />
        </div>
        <div v-show="localConfig.filterValues">
          <div class="md-layout md-gutter topBotMargin10">
            <div v-if="fieldTypeList" class="md-layout-item left-element">
              <VasionDropList
                v-slot="slotItem"
                v-model="fieldToFilter"
                :dataArray="fieldToFilterList"
                width="100%"
                title="FIELD TO FILTER"
                type="plain-list"
                displayName="title"
                valueName="title"
                placeholder="Select Field to Filter..."
                @input="fieldFilterUpdate"
              >
                {{ slotItem.item.title }}
              </VasionDropList>
            </div>
          </div>
          <div class="md-layout md-gutter topBotMargin10">
            <div class="md-layout-item left-element">
              <label class="section-header-label">{{ filterValueListTitle }}</label>
              <ul class="filter-value-list border vasion-ul">
                <li
                  v-for="(value, index) in localConfig.dropDownValues"
                  :key="index"
                  class="task"
                  :class="[value === selectedFilterValue ? 'selected' : '']"
                  @click="filterValueSelected(value)"
                >
                  <div class="task-text">
                    {{ value }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="md-layout-item">
              <label class="section-header-label">FILTER LIST</label>
              <ul class="filter-value-list border vasion-ul">
                <li
                  v-for="(value, index) in currentFilterFieldsList"
                  :key="index"
                  class="task"
                >
                  <VasionCheckbox
                    :id="`field-checkbox-${index}`"
                    class="field-checkbox"
                    :checked="value.selected"
                    @change="value.selected = !value.selected"
                  >    
                    {{ value.filterFieldValue }}
                  </VasionCheckbox>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </VasionGeneralModal>
    <VasionSnackbar
      id="results-snack"
      :showSnackbarBool.sync="showSnackbar"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'
import { readFileContent } from '@/store/helperModules/storage.module'

export default {
  name: 'NewFieldDialog',
  components: {
    Loading,
  },
  props: {
    builderMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    config: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    fieldTypeList: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      buildingFromExistingField: false,
      canEditTypeAndLength: false,
      creatingNewField: false,
      csvData: [],
      dropdownUpdated: false,
      editingField: false,
      fieldToFilter: {},
      fieldTypesWithValues: new Set([2, 9, 10]),
      fileImportErrorMessage: "",
      filePondLabel: `<span class="filepond-drag">Drag CSV File Here</span>
                <br/><br/>
                <span class="filepond-label-action">or click to upload your CSV File</span>`,
      formID: this.$route.params.formID,
      formName: '',
      importPreference: "overwrite-values",
      isLoading: false,
      listKey: 0,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      localConfig: this.config,
      piiData: false,
      mandatoryUpdated: false,
      newFieldValue: '',
      selectedFilterValue: '',
      serverOptions: { process: this.processHandler },
      showConfirmOverwriteModal: false,
      showDecimalPlaces: false,
      showFileImportedModal: false,
      showFileImportedErrorModal: false,
      showImpPrefModal: false,
      showSnackbar: false,
      showUploadDialog: false,
      showWarnLabel: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
      ssnMask: false,
      template: '',
      userUniqueName: '',
    }
  },
  computed: {
    activeForm() { return this.$store.state.attributeForm.activeIndexForm },
    allFieldHeaders() { return this.$store.state.forms.allFieldHeaders ? [{ name: '<New Field>' }, ...this.$store.state.forms.allFieldHeaders] : [] },
    currentFilterFieldsList() { return this.localConfig.filterFieldsList.filter(x => x.filterFieldName === this.fieldToFilter.name && x.baseFieldValue === this.selectedFilterValue) },
    fieldtypeWithValues() { return this.fieldTypesWithValues.has(this.localConfig.fieldType.id) },
    fieldToFilterList() { return this.fields.filter(x => x.type === 2 && x.name != this.localConfig.fieldUniqueName) },
    filterValueListTitle() { return `VALUES FOR ${this.localConfig.fieldLabel.toUpperCase()}` },
    searchName() { return 'name' },
    showDialog() { return this.creatingNewField || this.editingField },
    showUniqueNameInput() { return this.localConfig.fieldUniqueName === "<New Field>" },
    users() { return this.$store.state.common.users },
  },
  watch: {
    newFieldValue() {
      this.showWarnLabel = false
    },
    showDialog() {
      if (this.localConfig.decimalPlaces > 0) {
        this.showDecimalPlaces = true
      } else {
        this.showDecimalPlaces = false
      }
    }
  },
  created: function () {
    this.$store.dispatch('forms/getAllFieldHeaders')
  },
  methods: {
    async addNewField() {
      if (this.isSavingField) {
        return
      }

      this.isSavingField = true

      if (this.decimalPlacesOutOfRange()) {
        this.showFieldValidationError('Decimal Places must be between 0 and 15 inclusive.')
        return
      }

      if (this.lengthOutOfRange()) {
        this.showFieldValidationError('Textbox and Text Area must have a length between 1 and 4000.')
        return
      }

      if (!this.localConfig.fieldLabel || this.localConfig.fieldLabel === '') {
        this.showFieldValidationError('The Label cannot be empty.')
        return
      }

      if (this.localConfig.fieldLabel.trim() === '') {
        this.showFieldValidationError('The Label cannot only include spaces.')
        return
      }

      if (this.showUniqueNameInput && !this.userUniqueName) {
        this.showFieldValidationError('The Unique Name cannot be empty.')
        return
      } else if (!this.localConfig.fieldUniqueName) {
        this.showFieldValidationError('Please select a Field Option.')
        return
      }

      if (this.userUniqueName.trim() === '') {
        this.showFieldValidationError('The Unique Name cannot only include spaces.')
        return
      }

      // replace any illegal chars in the unique name

      let localUniqueName = this.localConfig.fieldUniqueName

      if (this.showUniqueNameInput) {
        localUniqueName = this.removeBadCharacters(this.userUniqueName)

        if (!localUniqueName) {
          localUniqueName = 'FieldName'
        }

        if (!this.userUniqueName.endsWith('_Field')) {
          localUniqueName += '_Field'
        }
        if (/^\d/.test(localUniqueName)) {
          localUniqueName = '_' + localUniqueName
        }
      }

      if (!this.ensureUniqueness(localUniqueName)) {
          this.showFieldValidationError(`A Field with the same Unique Name already exists on this ${$formsLabel.toLowerCase()}`)
          return
        }

      if (!this.localConfig.fieldType || !this.localConfig.fieldType.id) {
        this.showFieldValidationError('A Field Type must be provided')
        return
      }

      if (this.localConfig.fieldType.id === 1 && (!this.localConfig.fieldLength || this.localConfig.fieldLength <= 0)) {
        this.showFieldValidationError('A Field Length must be provided')
        return
      }

      const existingFieldType = await this.$store.dispatch('document/getFieldType', localUniqueName)

      // eslint-disable-next-line eqeqeq
      if (typeof existingFieldType !== 'undefined' && existingFieldType > 0 && existingFieldType != this.localConfig.fieldType.id) {
        this.showFieldValidationError(`The field exists on a different ${$formsLabel} with a different Field Type`)
        return
      }
      if (this.localConfig.fieldType.value === 'Dropdown' || this.dropdownUpdated || this.localConfig.mandatory) {
        this.checkIfFieldIsUsed(localUniqueName)
      }

      /**
       * We use concat and emit("update:fields") alongside the .sync attribute, so we
       * don't directly modify the prop, which is bad. Concat is required to
       * non-mutably create a list with the value appended. For more information,
       * read on non-mutable ways of adding / removing from arrays in javascript.
       */
      const field = this.buildAttributeFieldFromForm(true, localUniqueName)
      this.$store.dispatch('attributeForm/updateActiveFormField', field)
      this.$emit("update:fields", this.activeForm.fields)

      if (this.builderMode) {
        await this.saveField()
      }

      this.toggleAddNewField()
      this.isSavingField = false
      this.$emit('saved')
      await this.$amplitude.trackEvent('Field Saved', {isNewField: true})
    },
    addNewFieldOption() {
      const isFound = this.localConfig.dropDownValues.some(e => e === this.newFieldValue)
      if (!isFound) {
        this.dropdownUpdated = true
        this.localConfig.dropDownValues.push(this.newFieldValue.trim())
        this.newFieldValue = ''
      } else {
        this.showWarnLabel = true;
      }
    },
    allFilesUploaded() {
      this.showUploadDialog = false
      if (!this.showFileImportedErrorModal)
        this.showImpPrefModal = true
    },
    buildAttributeFieldFromForm(isNew, uniqueName) {
      return {
        name: uniqueName,
        title: this.localConfig.fieldLabel,
        type: parseInt(this.localConfig.fieldType.id, 10),
        allowMultiples: this.localConfig.allowMultiples,
        decimalPlaces: this.showDecimalPlaces ? this.localConfig.decimalPlaces : 0,
        dropDownValues: this.localConfig.dropDownValues ? [...this.localConfig.dropDownValues] : [],
        length: this.localConfig.fieldLength,
        fieldID: this.fieldId,
        fieldOrder: isNew ? this.fields.length + 1 : this.fieldOrder,
        hidden: this.localConfig.fieldHidden,
        mandatory: this.localConfig.mandatory,
        piiData: this.piiData,
        ssnMask: this.ssnMask,
        readOnly: this.localConfig.readOnly,
        showCommas: this.localConfig.showCommas,
        systemDate: this.localConfig.systemDate,
        totalPageNo: this.localConfig.totalPageNo,
        filterValues: this.localConfig.filterValues,
        filterFieldsList: this.localConfig.filterFieldsList,
        legacyField: !this.showUniqueNameInput,
      }
    },
    cancelImportPreference() {
      this.showImpPrefModal = false
    },
    cancelOverwrite() {
      this.showConfirmOverwriteModal = false;
      this.showImpPrefModal = true;
    },
    async checkIfFieldIsUsed(uniqueName) {
      const payload = {
        objectID: this.formID,
        uniqueFieldName: uniqueName,
      }
      const response = await this.$store.dispatch('forms/checkIfFieldIsUsedInAForm', payload)
      if (response === 'True') {
        this.$emit('promptUpdateAllFields', payload)
      }
    },
    confirmOverwrite() {
      this.showConfirmOverwriteModal = false
      this.localConfig.dropDownValues = this.csvData
      this.showFileImportedModal = true
    },
    decimalPlacesOutOfRange() {
      if (this.localConfig.decimalPlaces < 0 || this.localConfig.decimalPlaces > 15) {
        return true
      }
      return false
    },
    deleteFieldOption(index) {
      this.localConfig.dropDownValues.splice(index, 1)
      this.dropdownUpdated = true
      this.updateList()
    },
    async editField() {
      if (this.isSavingField) {
        return
      }

      this.isSavingField = true

      if (this.decimalPlacesOutOfRange()) {
        this.showFieldValidationError('Decimal Places must be between 0 and 15 inclusive.')
        return
      }

      if (this.lengthOutOfRange()) {
        this.showFieldValidationError('Textbox and Text Area must have a length between 1 and 4000.')
        return
      }

      if (!this.localConfig.fieldLabel || this.localConfig.fieldLabel === '') {
        this.showFieldValidationError('The Label cannot be empty')
        return
      }

      let field = this.fields.find((f) => f.name === this.editingFieldName)
      if (field) {
        field = this.buildAttributeFieldFromForm(false, field.name)
      }
      this.$store.dispatch('attributeForm/updateActiveFormField', field)
      this.$emit("update:fields", this.activeForm.fields)

      this.fieldFilterText = ''
      if (this.dropdownUpdated || this.mandatoryUpdated) {
       this.checkIfFieldIsUsed(field.name)
      }

      this.toggleFieldEdit('')
      this.isSavingField = false
      this.$emit('saved')
      await this.$amplitude.trackEvent('Field Saved', {isNewField: false})
    },
    ensureUniqueness: function (uniqueName) {
      if (uniqueName) {
        const lowerUniqueName = uniqueName.toLowerCase()
        const matching = this.fields.find((f) => f.name.toLowerCase() === lowerUniqueName)
        if (matching) {
          return false
        }
      }
      return true
    },
    fieldFilterUpdate() {
      if (this.selectedFilterValue === '' || this.fieldToFilter.name === undefined) return

      this.fieldToFilter.dropDownValues.forEach(value => {
        if (!this.localConfig.filterFieldsList.some(x => x.baseFieldValue === this.selectedFilterValue && x.filterFieldName === this.fieldToFilter.name && x.filterFieldValue === value)) {
          this.localConfig.filterFieldsList.push({
            "filterFieldName": this.fieldToFilter.name,
            "baseFieldValue": this.selectedFilterValue,
            "filterFieldValue": value,
            "selected": false,
          })
        }
      })

      this.localConfig.filterFieldsList.sort((a,b) => {
        if (a.filterFieldName == b.filterFieldName) {
          if (a.baseFieldValue == b.baseFieldValue) {
            return (a.filterFieldValue > b.filterFieldValue) ? 1 : -1
          }
          return (a.baseFieldValue > b.baseFieldValue) ? 1 : -1
        }
        return (a.filterFieldName > b.filterFieldName) ? 1 : -1
      })
    },
    fileImportedDone() {
      this.showFileImportedModal = false
    },
    fileImportErrorDone() {
      this.fileImportErrorMessage = ""
      this.showFileImportedErrorModal = false
    },
    filterValueSelected(value) {
       this.selectedFilterValue = value
       this.fieldFilterUpdate()
    },
    filterValuesUpdate() {
      this.localConfig.filterValues = !this.localConfig.filterValues
      if (this.selectedFilterValue === '' && this.localConfig.filterValues) {
        this.fieldToFilter = this.fieldToFilterList[0]
        this.selectedFilterValue = (this.localConfig.dropDownValues.length > 0) ? this.localConfig.dropDownValues[0] : ''
        this.fieldFilterUpdate()      
      }
    },
    importFile() {
      this.fileImportErrorMessage = ""
      this.showUploadDialog = true
    },
    importPreferenceContinue() {
      this.showImpPrefModal = false
      if (this.importPreference === "overwrite-values") {
        this.showConfirmOverwriteModal = true
      }else if (this.importPreference === "append-values") {
        this.localConfig.dropDownValues = [...new Set([...this.localConfig.dropDownValues,...this.csvData])]
        this.showFileImportedModal = true
      }
      this.importPreference = "overwrite-values"
    },
    lengthOutOfRange() {
      if (this.localConfig.fieldType.id == 1 || this.localConfig.fieldType.id == 13) {
        const value = parseInt(this.localConfig.fieldLength, 10)
        if (isNaN(value) || value < 1 || value > 4000) {
          return true
        }
      }
      return false
    },
    // eslint-disable-next-line
    processHandler: async function (fieldName, file, metadata, load, error, progress, abort) {
      let itemsWithCommas = false
      if (!file?.name.endsWith('.csv')) {
        error(true)
        this.fileImportErrorMessage = "The file is not a CSV file."
        this.showFileImportedErrorModal = true
        return
      }
      const fileContent = await readFileContent(file)
      let csvBufferData = fileContent.split("\r\n")
      csvBufferData.every((item, index) => {
        if (item.includes(",")) {
          itemsWithCommas = true
          return false
        }
        csvBufferData[index] = item.trimStart()
        return true
      })
      csvBufferData = csvBufferData.filter(item => item!='')

      if (itemsWithCommas) {
        error(true)
        this.fileImportErrorMessage = "Items with commas are not allowed."
        this.showFileImportedErrorModal = true
        return
      }
      this.csvData = csvBufferData
      progress(true, 0, 1024)
      load(file.name)
    },
    removeBadCharacters: function (fieldName){
        return fieldName.replace(/([^_0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+)/ug, '');
    },
    retryFileImport() {
      this.fileImportErrorMessage = ""
      this.showFileImportedErrorModal = false
      this.showUploadDialog = true
    },
    resetLocalFieldInfo() {
      this.editingFieldName = ''
      this.userUniqueName = ''
      this.localConfig.allowMultiples = true
      this.localConfig.dropDownValues = []
      this.localConfig.decimalPlaces = 0
      this.localConfig.showCommas = false
      this.localConfig.fieldUniqueName = '<New Field>'
      this.localConfig.fieldLabel = ''
      // eslint-disable-next-line
      this.localConfig.fieldType = this.fieldTypeList[0]
      this.localConfig.fieldValues = ''
      this.localConfig.fieldLength = 100
      this.fieldId = 0
      this.fieldOrder = 0
      this.localConfig.fieldHidden = false
      this.localConfig.mandatory = false
      this.piiData = false
      this.localConfig.readOnly = false
      this.localConfig.systemDate = false
      this.localConfig.totalPageNo = false
      this.localConfig.filterValues = false
      this.localConfig.filterFieldsList = []
      this.localConfig.legacyField = false
      this.fieldToFilter = {}
      this.selectedFilterValue = ''
      this.ssnMask = false
    },
    async saveField() {
      if (!this.validateSaveData()) {
        return
      }

      this.isLoading = true

      const payload = {
        formID: this.formID,
        field: {
          fieldID: 0,
          name: this.showUniqueNameInput ? this.userUniqueName : this.localConfig.fieldUniqueName,
          title: this.localConfig.fieldLabel,
          type: parseInt(this.localConfig.fieldType.id, 10),
          length: this.localConfig.fieldLength,
          allowMultiples: this.localConfig.allowMultiples,
          dropDownValues: [...this.localConfig.dropDownValues],
          mandatory: this.localConfig.mandatory,
          hidden: this.localConfig.fieldHidden,
          readOnly: this.localConfig.readOnly,
          piiData: this.piiData,
          ssnMask: this.ssnMask,
          totalPageNo: false,
          systemDate: false,
          fieldOrder: 0,
          filterValues: this.localConfig.filterValues,
          filterFieldsList: this.localConfig.filterFieldsList,
          legacyField: !this.showUniqueNameInput,
        },
      }
      await this.$store.dispatch('forms/saveNewField', payload)
      this.$emit('saved')
      this.isLoading = false
    },
    setDataFromActiveForm() {
      this.formName = this.activeForm.name
      this.formID = this.activeForm.id
      this.emit("update:fields", this.activeForm.fields)
    },
    setFieldValues(val) {
      if (val === "" || val === '<New Field>') {
        this.buildingFromExistingField = false
        this.resetLocalFieldInfo()
      } else {
        this.userUniqueName = ''
        this.buildingFromExistingField = true
        const selection = this.allFieldHeaders.filter(header => {
          return header.name === val
        })[0]
        this.localConfig.uniqueFieldNames = val
        this.localConfig.fieldLength = selection.length
        // eslint-disable-next-line
        this.localConfig.fieldType = this.fieldTypeList.filter(type => {
          return type.id === selection.type
        })[0]
      }
    },
    showFailureSaveMessage(messageDetail) {
      this.snackbarTitle = `Unable to update ${$formsLabel}`
      this.snackbarSubTitle = messageDetail
      this.snackbarImage = false
      this.showSnackbar = true
    },
    showFieldValidationError(messageDetail) {
      this.snackbarTitle = 'Error with Field'
      this.snackbarSubTitle = messageDetail
      this.snackbarImage = false
      this.showSnackbar = true
      this.isSavingField = false
    },
    ssnChange() {
      this.ssnMask = !this.ssnMask
      if(this.ssnMask && !this.editingField){
        this.localConfig.fieldLength = 11
      }
    },
    toggleAddNewField: function () {
      if (!this.creatingNewField) {
        // we're about to toggle it, so clear any old data
        this.resetLocalFieldInfo()
      }
      this.buildingFromExistingField = false
      this.creatingNewField = !this.creatingNewField
    },
    toggleFieldEdit: async function (fieldName) {
      this.editingFieldName = fieldName
      this.editingField = !this.editingField
      this.canEditTypeAndLength = false

      if (this.editingField) {
        const field = this.fields.find((f) => f.name === fieldName)
        if (field) {
          const foundFieldType = this.fieldTypeList.find((element) => {
            return element.id === field.type
          })
          this.localConfig.showCommas = field.showCommas
          this.localConfig.decimalPlaces = field.decimalPlaces
          this.localConfig.fieldUniqueName = field.name
          this.localConfig.fieldLabel = field.title
          this.localConfig.fieldType = foundFieldType
          this.localConfig.allowMultiples = field.allowMultiples
          this.localConfig.dropDownValues = field.dropDownValues && field.dropDownValues.length > 0 ? [...field.dropDownValues] : []
          this.localConfig.fieldLength = field.length
          this.fieldId = field.fieldID
          this.fieldOrder = field.fieldOrder
          this.localConfig.fieldHidden = field.hidden
          this.localConfig.mandatory = field.mandatory
          this.piiData = field.piiData
          this.ssnMask = field.ssnMask
          this.localConfig.readOnly = field.readOnly
          this.localConfig.systemDate = field.systemDate
          this.localConfig.totalPageNo = field.totalPageNo
          this.localConfig.filterValues = field.filterValues
          this.localConfig.filterFieldsList = field.filterFieldsList.map(a => ({...a}))
          
          const payload = {
            objectID: this.formID,
            fieldName: this.editingFieldName,
          }
          this.canEditTypeAndLength = await this.$store.dispatch('attributeForm/canEditFieldTypeOrLength', payload)

          if (this.localConfig.fieldType.id === 2)
          {
            this.fieldToFilter = this.fieldToFilterList[0]
            this.selectedFilterValue = (this.localConfig.dropDownValues.length > 0) ? this.localConfig.dropDownValues[0] : ''
            this.fieldFilterUpdate()
          }          
        }
      } else {
        this.resetLocalFieldInfo()
      }
    },
    updateList() {
      this.listKey += 1
    },
    validateSaveData() {
      // validate field uniqueness
      let errorMessage = ''
      const uniqueFieldNames = []

      this.fields.map((field) => {
        if (uniqueFieldNames.includes(field.name)) {
          errorMessage += `${field.name} is not a unique field name. `
          return false
        }

        uniqueFieldNames.push(field.name)
        return true
      })

      if (errorMessage) {
        this.showFailureSaveMessage(errorMessage)
        return false
      }

      return true
    },
  },
}
</script>
<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  .button-adjust {
    position: relative;
    top: 16px;
  }
  .number-checkbox-group {
    padding-top: 1em;
  }
  .checkbox-group {
    width: 90%;
  }
  .delete-option {
    cursor: pointer;
  }
  .innerDiv {
    padding-left: 16px;
    padding-top: 7px;
    padding-right: 16px;
    width: 100%;
  }
  .input-option-group {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .input-style {
    width: 100%;
  }

  .dialog {
    width: 1176px;
    height: 691px;
    text-align: left;
  }

  .left-element {
    padding-left: 0 !important;
    margin-left: 0;
  }

  .search-dropdown {
    margin-left: auto;
    padding-right: 20px;
    width: 25%;
  }

  .field-checkbox {
    margin-top: 8px;
    margin-right: 16px;
  }

  .checkbox-flex {
    flex: 1;
  }

  .topBotMargin10 {
    margin: 24px 0px 24px 0px;
  }

  .section-header {
    margin-top: 25px;
  }
  .section-header-label {
    color: $grey-400;
    font-weight: 400;
    font-size: 12px;
  }
  
  .title {
    display: flex;
  }

  .value {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;
    height: 48px;
    font-size: 14px;
  }

  .value-list {
    overflow-y: auto;
  }

  .value-list-header {
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 1px 0 0 $grey-100;
    padding: 18px 16px;
    margin-bottom: 0;
    border-bottom: 1px solid #e4e5e6;
  }
  .warnLabel {
    margin-top: -15px;
    color: red;
  }

  .filter-value-list {
    min-height: 200px;
    max-height: 200px;
    overflow: auto;
  }

  .selected {
    background-color: $orange-50;
    color: $orange-400;
    fill: $orange-400;
  }

  .border{
    border: solid 1px;
    border-radius: 8px;
    border-color: $grey-200;
  }

  .filter-list-text{
    padding-left: 10px;
    overflow: hidden;
  }
  .vasion-check{
    fill: $grey-400;
  }
  .vasion-check-selected{
    fill: $orange-400;
  }
  .file-upload-container::v-deep #vasionFileUploadDialog {
    z-index: 25;
  }
  .file-upload-container::v-deep .overlay {
    z-index: 25;
  }
  .cvs-note {
    margin-bottom: 0px;
    text-align: right;
  }
</style>
